<template>
  <div v-loading="loading" class="clashComp" :style="{ height: height, top: top }">
    <el-card shadow="never" class="clash_list">
      <div slot="header" class="clearfix business_dialog_title m-b-5">
        <span class="fz-14">碰撞清单</span>
        <i class="iconfont icon-close r cur_pointer" @click="closeComponent"></i>
      </div>
      <div class="h-100">
        <el-row :gutter="10">
          <el-col :span="7">
            <el-input
              v-model="searchData.clashReportNumber"
              @keyup.native.enter="searchFilterData"
              size="small"
              placeholder="碰撞编号"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="7">
            <el-input
              size="small"
              clearable
              @keyup.native.enter="searchFilterData"
              v-model="searchData.discipline"
              placeholder="处理专业"
            ></el-input>
          </el-col>
          <el-col :span="7">
            <el-select
              filterable
              size="small"
              class="w-100"
              clearable
              @change="searchFilterData"
              v-model="searchData.flowStatus"
              placeholder="处理状态"
            >
              <el-option
                v-for="item in flowTypes"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-tooltip effect="dark" content="查询" placement="top" :open-delay="1000">
              <el-button
                class="button-color"
                type="primary"
                @click="searchFilterData"
                icon="iconfont icon-yxr-ss"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="m-t-10 clash_table">
          <el-table
            ref="tableRef"
            :data="tableData"
            border
            height="100%"
            highlight-current-row
            @row-click="setRowData"
          >
            <el-table-column
              label="碰撞编号"
              show-overflow-tooltip
              prop="clashReportNumber"
            ></el-table-column>
            <el-table-column label="处理专业" prop="disciplineName"></el-table-column>
            <el-table-column label="处理状态" prop="flowStatus">
              <template slot-scope="scope">
                {{
                  scope.row.flowStatus === 0
                    ? '新增'
                    : scope.row.flowStatus === 1
                    ? '已反馈'
                    : scope.row.flowStatus === 2
                    ? '已处理'
                    : typeof scope.row.flowStatus === 'string'
                    ? scope.row.flowStatus
                    : '已关闭'
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="m-t-5 r">
          <el-pagination
            ref="pagination"
            background
            :pager-count="5"
            @current-change="changePageNo"
            :current-page.sync="page.pageNo"
            :page-size.sync="page.pageSize"
            layout="total, prev, pager, next"
            :total="page.pageTotal"
          ></el-pagination>
        </div>
      </div>
    </el-card>
    <el-card shadow="never" class="m-t-10 clash_detail">
      <div slot="header" class="clearfix m-b-5">
        <span class="fz-14">碰撞信息</span>
        <el-tooltip placement="top" content="会议记录" :open-delay="1000">
          <el-button
            class="r button-color"
            :disabled="!((moduleAuth && moduleAuth.read) || currentEnv.DEBUG)"
            icon="iconfont icon-file"
            @click="flowDialogVisible = true"
          ></el-button>
        </el-tooltip>
      </div>
      <div class="h-95 tableDiv">
        <div class="cable-info">
          <div class="cable-info__list b-none d-flex flex-align-center">
            <p class="info-left fz-12">所在区域</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.area : '' }}
            </p>
          </div>
          <div class="cable-info__list d-flex flex-align-center b-none">
            <p class="info-left fz-12">碰撞主体编码</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.tagA.tagCode : '' }}
            </p>
            <span
              class="p-r-10 iconfont icon-localtion"
              @click="findComponentInPlayer(rowData.tagA.tagCode || '')"
              v-show="rowData && rowData.clashTagA"
            ></span>
          </div>
          <div class="cable-info__list d-flex flex-align-center b-none">
            <p class="info-left fz-12">碰撞主体名称</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.tagA.tagName : '' }}
            </p>
          </div>
          <div class="cable-info__list d-flex flex-align-center b-none">
            <p class="info-left fz-12">碰撞客体编码</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.tagB.tagCode : '' }}
            </p>
            <span
              class="p-r-10 iconfont icon-localtion"
              @click="findComponentInPlayer(rowData.tagB.tagCode || '')"
              v-show="rowData && rowData.clashTagB"
            ></span>
          </div>
          <div class="cable-info__list d-flex flex-align-center b-none">
            <p class="info-left fz-12">碰撞客体名称</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.tagB.tagName : '' }}
            </p>
          </div>
          <div class="cable-info__list d-flex flex-align-center">
            <p class="info-left fz-12">施工状态</p>
            <p v-if="!rowData" class="text-color-white p-l-10 p-r-10 flex-1"></p>
            <p v-else class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{
                rowData.constructionStatus === 0
                  ? '已施工'
                  : typeof (rowData.constructionStatus === 'string')
                  ? rowData.constructionStatus
                  : '未施工'
              }}
            </p>
          </div>
          <div class="cable-info__list d-flex flex-align-center">
            <p class="info-left fz-12">坐标</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.coordinate : '' }}
            </p>
            <span
              class="p-r-10 iconfont icon-localtion"
              v-show="rowData && rowData.coordinate"
              @click="findComponentInPlayer(rowData.coordinate || '')"
            ></span>
          </div>
          <div class="cable-info__list d-flex flex-align-center">
            <p class="info-left fz-12">内容</p>
            <p class="text-color-white fz-12 p-l-10 p-r-10 flex-1">
              {{ rowData ? rowData.content : '' }}
            </p>
          </div>
        </div>
      </div>
      <div class="h-10" v-if="showCheck">
        <el-button
          type="success"
          size="small"
          class="w-100"
          @click="openCheckDialog(0)"
          :loading="handleLoading"
          :disabled="!((moduleAuth && moduleAuth.update) || currentEnv.DEBUG)"
          >处理</el-button
        >
      </div>
    </el-card>
    <!-- 处理弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="编辑碰撞报告"
      :visible.sync="editDialog"
      @close="cancelDialog"
      width="50%"
      top="8vh"
    >
      <div class="w-100 deal_dialog">
        <el-form class="w-98" :model="clashDetail" label-position="left" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="碰撞区域">
                <el-input
                  type="text"
                  v-model="clashDetail.area"
                  :disabled="
                    clashDetail.flowStatus === 3 || this.flowEndStatus || !isCurrentApprover
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理专业">
                <el-select
                  popper-class="document_select-popper"
                  filterable
                  v-model="clashDetail.discipline"
                  clearable
                  placeholder
                  class="w-100"
                  :disabled="
                    clashDetail.flowStatus === 3 || this.flowEndStatus || !isCurrentApprover
                  "
                >
                  <el-option
                    v-for="(item, index) in majorList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="内容">
            <el-input
              class="inputDiv"
              type="textarea"
              v-model="clashDetail.content"
              :disabled="clashDetail.flowStatus === 3 || this.flowEndStatus || !isCurrentApprover"
            ></el-input>
          </el-form-item>
          <el-table
            :data="clashDetail.clashObj"
            class="w-100"
            border
            :default-sort="{ prop: 'isMain', order: 'descending' }"
          >
            <el-table-column prop="tagName" label="碰撞对象名称" width>
              <template slot-scope="scope">
                <div v-if="scope.row.isMain === 1">
                  <span v-if="!renameTagAStatus">{{ scope.row.tagName }}</span>
                  <el-input
                    v-else
                    v-model="scope.row.tagName"
                    @keyup.enter.native="renameTag(scope.row)"
                  ></el-input>
                </div>
                <div v-if="scope.row.isMain === 0">
                  <span v-if="!renameTagBStatus">{{ scope.row.tagName }}</span>
                  <el-input
                    v-else
                    v-model="scope.row.tagName"
                    @keyup.enter.native="renameTag(scope.row)"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tagCode" label="碰撞对象编码" width>
              <template slot-scope="scope">
                <div v-if="scope.row.isMain === 1">
                  <span v-if="!renameTagAStatus">{{ scope.row.tagCode }}</span>
                  <el-input
                    v-else
                    v-model="scope.row.tagCode"
                    @keyup.enter.native="renameTag(scope.row)"
                  ></el-input>
                </div>
                <div v-if="scope.row.isMain === 0">
                  <span v-if="!renameTagBStatus">{{ scope.row.tagCode }}</span>
                  <el-input
                    v-else
                    v-model="scope.row.tagCode"
                    @keyup.enter.native="renameTag(scope.row)"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="relatedDrawing" label="所在图纸">
              <template slot-scope="scope">
                <p class="p-b-10" v-for="(i, index) in scope.row.relatedDrawing" :key="index">
                  {{ i.name }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="disciplineName" label="专业" width="100px"></el-table-column>
            <el-table-column label="操作" width>
              <template slot-scope="scope">
                <el-tooltip placement="top" content="查看" :open-delay="1000">
                  <el-button size="mini" type="info" @click="checkTag(scope.row)">
                    <i class="iconfont icon-display"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip placement="top" content="重命名" :open-delay="1000">
                  <el-button size="mini" type="warning" @click="openRenameInput(scope.row)">
                    <i class="iconfont icon-edit"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-row
              :gutter="10"
              type="flex"
              align="middle"
              justify="space-between"
              class="p-t-20 p-b-20"
              v-for="(item, index) in flowCommentAndAttach"
              :key="index"
            >
              <el-col :span="2">
                <div class="tc">
                  <img src="/static/img/user.png" alt />
                  <span>{{ item.ReceiveName }}</span>
                </div>
              </el-col>
              <el-col :span="3" class="tc">
                <div>{{ item.ReceiveTime }}</div>
              </el-col>
              <el-col :span="14">
                <el-input
                  class="inputDiv"
                  type="textarea"
                  v-model="item.Comments"
                  disabled
                ></el-input>
              </el-col>
              <el-col :span="4">
                <template v-if="!_.isEmpty(item.fileChildren)">
                  <div
                    v-for="child in item.fileChildren"
                    :key="child.md5"
                    class="cur_pointer text-color-blue"
                    @click="fileDownload(child)"
                  >
                    {{ child.name }}
                  </div>
                </template>
                <div class="c-g9 tc" v-else>无附件</div>
              </el-col>
            </el-row>
            <el-row
              :gutter="10"
              type="flex"
              align="middle"
              justify="space-between"
              class="p-t-20 p-b-20"
              v-if="isCurrentApprover && clashDetail.flowStatus !== 3"
            >
              <el-col :span="2">
                <div class="tc">
                  <img src="/static/img/user.png" alt />
                  <span>{{ userInfo.trueName }}</span>
                </div>
              </el-col>
              <el-col :span="14">
                <el-input class="inputDiv" type="textarea" v-model="approveAdvice"></el-input>
              </el-col>
              <el-col :span="4" class="uploadDiv">
                <UploadFilesDrag
                  :hdd="true"
                  :flowStepId="currentTaskId"
                  :ownerId="clashDetail.id"
                  :multiple="true"
                  @uploadFinish="uploadApproveFile"
                ></UploadFilesDrag>
              </el-col>
              <el-col :span="4">
                <div v-if="approveAttchment.length > 0">
                  <h3 class="b m-b-10">已上传附件</h3>
                  <ul class="list-unstyled">
                    <li v-for="(i, index) in approveAttchment" :key="index">
                      <span class="text-color-blue cur_pointer">{{ i.name }}</span>
                      <i
                        class="iconfont icon-delete cur_pointer has-text-danger"
                        @click="removeApproveFile(i)"
                      ></i>
                    </li>
                  </ul>
                </div>
                <div class="c-g9 tc" v-else>无附件</div>
              </el-col>
            </el-row>
          </div>

          <div class="tr p-b-30">
            <!-- 加个复选框判断流程条件 -->
            <div
              v-if="isCurrentApprover && clashDetail.flowStatus === 1"
              class="p-t-20"
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              <el-checkbox
                v-model="isHandledStatus"
                label="已处理"
                @change="handledChecked"
              ></el-checkbox>
            </div>
            <div
              v-if="clashDetail.flowStatus !== 3 && !this.flowEndStatus && isCurrentApprover"
              class="p-t-20"
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              <el-radio-group v-model="currentSendLabel" size="medium" @change="flowSendTypeChange">
                <el-radio
                  class="p-r-10"
                  v-for="(item, index) in flowSendType"
                  :key="index"
                  :label="item.label"
                  :disabled="
                    (clashDetail.flowStatus === 0 && item.type === 'back') ||
                      (clashDetail.flowStatus === 0 && item.type === 'taskend') ||
                      (!isLastFlowNode && item.type === 'completed') ||
                      (isLastFlowNode && item.type === 'submit')
                  "
                ></el-radio>
              </el-radio-group>
            </div>
            <div
              class="p-t-20"
              v-if="clashDetail.flowStatus !== 3 && !this.flowEndStatus && isCurrentApprover"
            >
              <el-button
                type="primary"
                size="small"
                @click="editAndSendFlow"
                :loading="editAndSendLoading"
                >保存并流转</el-button
              >
              <el-button size="small" @click="cancelDialog">取消</el-button>
            </div>
            <div
              class="p-t-20"
              v-if="clashDetail.flowStatus === 3 || this.flowEndStatus || !isCurrentApprover"
            >
              <el-button size="small" @click="cancelDialog">取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="会议记录"
      :visible.sync="recordDialog"
      @close="recordTable = []"
      width="700px"
    >
      <el-table :data="recordTable" border stripe height="400px">
        <el-table-column label="序号" width="90px">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="会审结果" prop="result"></el-table-column>
        <el-table-column label="记录人" prop="createdUserName"></el-table-column>
        <el-table-column label="记录时间">
          <template slot-scope="scope">{{
            moment(scope.row.createdTime).format('YYYY-MM-DD HH:mm:ss')
          }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 流程处理过程 -->
    <el-dialog
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="流程处理过程"
      :visible.sync="flowDialogVisible"
      v-if="flowDialogVisible"
      class="dialogDiv"
    >
      <iframe :src="flowIframeUrl" class="w-100 flow_dialog"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import ConfirmAuth from '@/assets/js/confirmAuth'
import ApiMixinClashManagement from '@/assets/js/api/clash'
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import ApiMixinDocument from '@/assets/js/api/documents'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import UploadFilesDrag from '@/components/uploadFilesDrag'

export default {
  name: 'clashList',
  mixins: [
    ApiMixinCable,
    ApiMixinClashManagement,
    FnMixins,
    ApiMixinDocument,
    ApiMixinDictionaryManagement,
  ],
  components: {
    UploadFilesDrag,
  },
  props: ['documentId', 'player', 'height', 'top', 'loadedModel'],
  data() {
    return {
      searchData: {
        clashReportNumber: '',
        discipline: '',
        flowStatus: '',
        lifeCycleStatus: '',
      },
      showCheck: '',
      eidtTable: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      moduleAuth: null,
      renameTagAStatus: false, // 重命名
      renameTagBStatus: false, // 重命名
      editDialog: false,
      flowTypes: [
        {
          value: 0,
          label: '新增',
        },
        {
          value: 1,
          label: '已反馈',
        },
        {
          value: 2,
          label: '已处理',
        },
        {
          value: 3,
          label: '已关闭',
        },
      ],
      /**
       * 流程相关
       */
      flowSendType: [
        {
          value: 1,
          label: '下一步',
          type: 'submit',
        },
        {
          value: 2,
          label: '退回',
          type: 'back',
        },
        {
          value: 3,
          label: '终止',
          type: 'taskend',
        },
        {
          value: 4,
          label: '完成',
          type: 'completed',
        },
      ],
      editAndSendLoading: false,
      // 编辑碰撞信息表单
      clashDetail: {
        clashReportNumber: '',
        submitDate: '',
        constructionStatus: 0,
        area: '',
        discipline: '',
        content: '',
        clashObj: [],
        flowStatus: '',
      },
      recordDialog: false,
      tableData: [],
      recordTable: [],
      clashFlowId: '', // 当前流程id
      allFlows: [], // 系统的所有流程
      flowEndStatus: false, // 当前流程是否终止
      flowApprovers: [], // 下一步流程审批人
      currentSendLabel: '下一步',
      isCurrentApprover: true, // 是否是当前审批人
      flowCommentAndAttach: [], // 附件和评论集合
      approveAdvice: '', // 审批意见
      currentTaskId: '', // 当前步骤id,附件上传绑定用
      isLastFlowNode: false, // 是否是流程的最后一个节点
      approveAttchment: [], // 审批附件
      listLoading: false,
      nextStep: [], // 发送或者退回的步骤
      clashFlow: null, // 碰撞管理流程
      toDoList: [], // 待办列表
      rowData: null, // 碰撞信息
      majorList: [], // 处理专业列表
      currentSendType: 'submit',
      toDoFlowCurrent: null, // 当前待办
      flowSystemCode: 'localhost', // 流程系统标识
      flowIframeUrl: '', // 流程日志|流程图的iframe地址
      clickButton: false,
      isHandledStatus: false, // 已处理
      checkDetailData: [], // 编辑详情数据
      handleLoading: false, // 处理按钮loading
      flowDialogVisible: false, // 流程处理状态弹框
      loading: false,
      timeOut: null,
      gisMarkerList: [], // 标记idlist
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
    }
  },
  computed: {
    pixelCullingThres() {
      const obj = _.find(this.systemParams, { parameterCode: 'pixelCullingThres' })
      return obj ? obj.parameterValue * 1 : 5
    },
    documentTabHeight() {
      return `${(window.innerHeight - 200) / 2}`
    },
    pageTags() {
      return this.$store.getters.pageTags || []
    },
    playerServer() {
      const playerServer = _.find(this.systemParams, { parameterCode: 'playerServer' })
      return playerServer ? playerServer.parameterValue : null
    },
    playerServerProtocol() {
      const playerServerPro = _.find(this.systemParams, { parameterCode: 'playerServerProtocol' })
      return playerServerPro ? playerServerPro.parameterValue : null
    },
    cardHeight() {
      return `${window.innerHeight - 140}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
    flowName() {
      const flow = _.find(this.systemParams, { parameterCode: 'clashReportFlowName' })
      return flow ? flow.parameterValue : null
    },
  },
  watch: {
    async $route(to) {
      this.moduleAuth = await ConfirmAuth('三维检查')
    },
    loadedModel(loaded) {
      if (loaded) {
        // 等模型移动之后再定位
        setTimeout(() => {
          this.startDrawPoint(JSON.stringify(this.rowData))
        }, 200)
      }
    },
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'clashList')
    },
    // 初始化拿取工作流
    async getWorkFlow() {
      await this.getClashFlowId()
      if (this.clashFlowId === '') {
        return
      }
      this.toDoList = await this.getBackLog()
      this.doneList = await this.getDoneLog()
      this.allDoneList = await this.getAllDoneLog()
      await this.getFlowDetail()
    },
    // 当从碰撞模块进入时，拿去信息
    async getClashPosition() {
      console.log(this.$route.query.clashReportId)
      this.showCheck = this.$route.query.showCheck ? this.$route.query.type === 'clashList' : false
      // 获取关键字
      const clashReportId = this.$route.query.clashReportId ? this.$route.query.clashReportId : ''
      if (this.$route.query.type === 'clashList' && clashReportId !== '') {
        this.page.pageSize = this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10
        // 获取
        const params = {
          id: clashReportId,
          clashReportNumber: this.searchData.clashReportNumber,
          area: '',
          dateType: '',
          dateStart: '',
          dateEnd: '',
          drawingCode: '',
          tagCode: '',
          flowStatus: this.searchData.flowStatus,
          approver: '',
          discipline: '',
          constructionStatus: '',
          siteId: this.currentProject.id,
          pageSize: this.page.pageSize,
        }
        const res = await this.ApiClashReport({
          method: 'findIndex',
          params,
        })
        if (res && res.code === 0 && res.data) {
          console.log(res, 'findIndex')
          this.page.pageNo = res.data
          console.log(res.data, this.page.pageNo, 'res.data')
        }
      }
    },
    // 移动摄像头
    async moveCameraByCode(code, face = 0) {
      const query = {
        aabb: {
          min: [0, 0, 0],
          max: [0, 0, 0],
        },
        mat: {},
        face, // 视角
        kDistance: 1.1, // 与包围盒中心的距离系数
        second: 2,
      }
      /**
       * 设置是否需要摆正视角
       * 有地球时，不需要摆正
       */
      if (this.currentProject.latitude !== '' && this.currentProject.longitude !== '') {
        /**
         * Top = 1
         * Bottom = 2
         * Front = 4
         * Back = 8
         * Left = 18
         * Right = 32
         */
        query.face = 0 // 不改变视角
      }
      //  获取模型包围盒信息
      if (code && code.includes(',')) {
        const temp = code.split(',')
        const arr = [] // 锚点位置
        _.forEach(temp, (el, index) => {
          arr[index] = Number(el.split(':')[1].replace(/[^0-9\-.]/gi, '')) / 1000.0
        })
        // 计算锚点包围盒
        query.aabb = {
          min: [arr[0] - 1, arr[1] - 1, arr[2] - 1],
          max: [arr[0] + 1, arr[1] + 1, arr[2] + 1],
        }
        // 获取模型所在的坐标系
        const res = await PlayerUtils.call(
          this.player.Native.Model.getModelGlobalMatrix,
          this.documentId
        )
        query.mat = res
      } else {
        const res = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, code)
        query.aabb = res.localAabb
        query.mat = res.localMatrix
      }
      this.player.Native.Camera.moveToAabb(
        query.aabb,
        query.mat,
        query.face,
        query.kDistance,
        query.second
      )
      const itemInfo = await PlayerUtils.call(this.player.Native.ModelTree.getItemByCode, code)
      this.player.Native.ModelTree.setSelectItem(itemInfo.item)
    },
    /**
     * 碰撞定位锚点
     */
    async startDrawPoint(val) {
      if (!this.loadedModel) {
        console.log('模型未加载成功...')
        return
      }
      const info = JSON.parse(val)
      const temp = info.coordinate.split(',')
      const arr = []
      // 清除之前所有的颜色
      await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)

      this.player.Native.ModelTree.setItemColor([info.tagA.tagCode, info.tagB.tagCode], 0xbf09ecff)
      _.forEach(temp, (el, index) => {
        arr[index] = Number(el.split(':')[1].replace(/[^0-9\-.]/gi, '')) / 1000.0
      })
      // 检查是否有已知的标记
      const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)

      const currenMarkInfo = _.find(markerList, (res) => {
        return this.gisMarkerList.includes(res.id)
      })
      if (currenMarkInfo) {
        this.updatePoint(arr, currenMarkInfo.id)
      } else {
        this.drawPoint(arr)
      }
      // 定位到锚点
      this.codeList = [info.tagA.tagCode]
      this.moveCameraByCode(info.coordinate)
    },
    // 绘制锚点
    async drawPoint(pos) {
      // 加载锚点
      const imgId = await PlayerUtils.call(
        this.player.Native.GisMarker.loadImage,
        'data://icon/qietu/point.png'
      )
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [20, 20], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-10, -10], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [20, 20], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text: '', // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      this.gisMarkerList.push(await this.player.Native.GisMarker.create(option))
    },
    // 更新锚点
    updatePoint(pos, markerId) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
      }
      this.player.Native.GisMarker.update(markerId, option)
    },
    async searchFilterData() {
      this.rowData = null
      this.clickButton = true
      this.page.pageNo = 1
      this.tableData = await this.initData()

      // 默认显示第一条碰撞信息
      if (this.tableData.length > 0) {
        this.setRowData(this.tableData[0])
      }
    },
    // 查看会议记录
    async showRecord() {
      if (this.rowData && this.rowData.id) {
        this.recordDialog = true
        const res = await this.apiCable({ method: 'record', params: { id: this.rowData.id } })
        if (res && res.code === 0 && res.data) {
          this.recordTable = res.data
        } else {
          this.recordTable = []
        }
      } else {
        this.$message.info('请先选择碰撞')
        this.recordTable = []
      }
    },
    // 关闭弹窗
    cancelDialog() {
      this.editDialog = false
      this.clearForm()
    },
    // 加载碰撞数据表格数据
    async initData() {
      if ((this.moduleAuth && this.moduleAuth.read) || currentEnv.DEBUG) {
        this.listLoading = true
        console.log(this.page.pageNo, 'this.page.pageNo')
        const params = {
          clashReportNumber: this.searchData.clashReportNumber,
          area: '',
          dateType: '',
          dateStart: '',
          dateEnd: '',
          drawingCode: '',
          tagCode: '',
          flowStatus: this.searchData.flowStatus,
          approver: '',
          discipline: '',
          constructionStatus: '',
          siteId: this.currentProject.id,
          pageSize: this.page.pageSize,
          pageNo: this.page.pageNo,
          disciplinename: this.searchData.discipline,
        }
        console.log(params, 'params')
        if (this.cableId !== 'noCableId' && !this.clickButton) {
          params.id = this.cableId
        }
        const res = await this.ApiClashList({
          method: 'query',
          params,
        })
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.page.pageTotal = res.page && res.page.recordCount > 0 ? res.page.recordCount : 0
          return res.data
        }
        this.page.pageTotal = 0
        return []
      }
      return []
    },
    // 切换页码
    async changePageNo(page) {
      this.page.pageNo = page
      this.tableData = await this.initData()
    },
    // 单击表格中的某一行数据
    setRowData(row) {
      if (!row) return
      if (this.timeOut) clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.rowData = row
        this.$refs.tableRef.setCurrentRow(row)
        this.startDrawPoint(JSON.stringify(this.rowData))
        /**
         * 待办为空，流程状态为0-->未发起
         * 待办不为空，流程状态不为0-->流转中
         * 已办的executeType=11或者12-->已终止
         * 流程状态为3-->已完成
         * 待办为空，流程状态不为0-->不是当前处理人（同终止的判断类似，但是终止的判断用流程的返参）
         */
        if (!_.isEmpty(this.toDoList)) {
          ;[this.toDoFlowCurrent] = _.filter(this.toDoList, { instanceid: this.rowData.id })
          if (this.toDoFlowCurrent) {
            this.flowIframeUrl = `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCore/FlowTask/Embeddetail?flowid=${this.clashFlowId}&stepid=&groupid=${this.toDoFlowCurrent.groupid}&taskid=`
          } else {
            console.log('没有相关的流程信息————————————')
          }
        }
      }, 800)
      if (!_.isEmpty(this.doneList)) {
        ;[this.doneFlowCurrent] = _.filter(this.doneList, { instanceid: row.id })
        if (this.doneFlowCurrent) {
          this.flowIframeUrl = `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCore/FlowTask/Embeddetail?flowid=${this.clashFlowId}&stepid=&groupid=${this.doneFlowCurrent.groupid}&taskid=`
        } else {
          console.log('没有相关的流程信息————————————')
        }
      }
    },
    // 处理
    async openCheckDialog() {
      this.eidtTable = Object.assign(this.rowData)
      await this.getClashDetail(this.rowData)
      this.editDialog = true
      this.toDoList = await this.getBackLog()
      this.doneList = await this.getDoneLog()
      this.allDoneList = await this.getAllDoneLog()
      // 筛选流程最后一步
      const lastStep = _.filter(this.clashFlow.steps, (item) => {
        return item.name === '关闭'
      })
      /**
       * 待办为空，流程状态为0-->未发起
       * 待办不为空，流程状态不为0-->流转中
       * 已办的executeType=11或者12-->已终止
       * 流程状态为3-->已完成
       * 待办为空，流程状态不为0-->不是当前处理人（同终止的判断类似，但是终止的判断用流程的返参）
       */
      if (this.toDoList.length > 0) {
        ;[this.toDoFlowCurrent] = _.filter(this.toDoList, { instanceid: this.rowData.id })
        console.log(this.toDoFlowCurrent)
        if (this.toDoFlowCurrent) {
          // 判断当前流程步骤最后一步
          console.log(this.toDoFlowCurrent)
          if (this.toDoFlowCurrent.stepid === _.toLower(lastStep[0].id)) {
            this.isLastFlowNode = true
          }
        } else {
          this.toDoFlowCurrent = null
        }
      } else {
        this.toDoFlowCurrent = null
      }
      if (this.doneList.length > 0) {
        ;[this.doneFlowCurrent] = _.filter(this.doneList, { instanceid: this.rowData.id })
        console.log('当前已办最新', this.doneFlowCurrent)
        if (this.doneFlowCurrent) {
          // 判断流程是否终止
          if (this.doneFlowCurrent.executeType === 11 || this.doneFlowCurrent.executeType === 12) {
            // 流程终止
            this.flowEndStatus = true
          }
        } else {
          this.doneFlowCurrent = null
        }
      } else {
        this.doneFlowCurrent = null
      }
      console.log('待办流程和已办流程', this.toDoFlowCurrent, this.doneFlowCurrent)
      if (this.clashDetail.flowStatus === 0) {
        this.toDoFlowCurrent = null
        this.clashFlow.steps[0].behavior.defaultHandler = _.split(
          this.clashFlow.steps[0].behavior.defaultHandler,
          ','
        )
        console.log('第一步处理人', this.clashFlow.steps[0].behavior.defaultHandler)
        if (
          _.includes(
            this.clashFlow.steps[0].behavior.defaultHandler,
            `u_${_.toLower(this.userInfo.userId)}`
          )
        ) {
          this.isCurrentApprover = true
        } else {
          this.isCurrentApprover = false
        }
      } else if (this.toDoFlowCurrent) {
        this.isCurrentApprover = true
        this.flowIframeUrl = `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCore/FlowTask/Embeddetail?flowid=${this.clashFlowId}&stepid=&groupid=${this.toDoFlowCurrent.groupid}&taskid=`
        console.log(this.flowIframeUrl)
        const groupTask = await this.getGroupTask(this.toDoFlowCurrent.groupid)
        const detailAttachments = this.clashDetail.attachments
        console.log(groupTask, 'groupTask')
        console.log(detailAttachments, 'detailAtrtachments')
        _.forEach(groupTask, (item, index) => {
          console.log(item.ReceiveTime)
          item.ReceiveTime = _.replace(item.ReceiveTime, 'T', ' ')
          item.fileChildren = []
          _.forEach(detailAttachments, (child) => {
            if (child.flowStepId === item.Id) {
              item.fileChildren.push(child)
            }
            if (_.isNull(child.flowStepId) && index === 0) {
              item.fileChildren.push(child)
            }
          })
        })
        console.log('组合实例列表', groupTask)
        this.flowCommentAndAttach = _.filter(groupTask, (item) => {
          return item.ExecuteType !== 0
        })
        console.log('组合当前评论和附件列表', this.flowCommentAndAttach)
      } else if (this.doneFlowCurrent) {
        // 待办为空，流程状态不为零，已办事项不为空
        this.isCurrentApprover = false
        this.flowIframeUrl = `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCore/FlowTask/Embeddetail?flowid=${this.clashFlowId}&stepid=&groupid=${this.doneFlowCurrent.groupid}&taskid=`
        const groupTask = await this.getGroupTask(this.doneFlowCurrent.groupid)
        const detailAttachments = this.clashDetail.attachments
        _.forEach(groupTask, (item, index) => {
          console.log(item.ReceiveTime)
          item.ReceiveTime = _.replace(item.ReceiveTime, 'T', ' ')
          item.fileChildren = []
          _.forEach(detailAttachments, (child) => {
            if (child.flowStepId === item.Id) {
              item = _.assign(item, child)
              item.fileChildren.push(child)
            }
            if (_.isNull(child.flowStepId)) {
              groupTask[0] = _.assign(groupTask[0], child)
            }
            if (_.isNull(child.flowStepId) && index === 0) {
              item.fileChildren.push(child)
            }
          })
        })
        console.log('组合实例列表', groupTask)
        this.flowCommentAndAttach = _.filter(groupTask, (item) => {
          return item.ExecuteType !== 0
        })
        console.log('组合当前评论和附件列表', this.flowCommentAndAttach)
      } else if (!this.toDoFlowCurrent && !this.doneFlowCurrent) {
        // 待办已办数据都为空，用户和流程无关
        this.allDoneList = _.filter(this.allDoneList, { instanceid: this.clashDetail.id })
        if (this.allDoneList.length > 0) {
          const groupidNow = this.allDoneList[0].groupid
          this.isCurrentApprover = false
          this.flowIframeUrl = `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCore/FlowTask/Embeddetail?flowid=${this.clashFlowId}&stepid=&groupid=${groupidNow}&taskid=`
        } else {
          // 当前流程不存在
          console.log('当前流程不存在')
        }
      }
      console.log(this.flowIframeUrl, !this.toDoFlowCurrent && !this.doneFlowCurrent)
      // 当前步骤id设置
      if (this.clashDetail.flowStatus === 0 && this.isCurrentApprover) {
        this.currentTaskId = ''
      } else if (this.toDoFlowCurrent && this.isCurrentApprover) {
        this.currentTaskId = this.toDoFlowCurrent.id
      }
      console.log('查看当前步骤id', this.currentTaskId)
    },
    /**
     * 模型列表
     */
    // 获取模型列表

    // 定位模型
    findComponentInPlayer(code) {
      // 移动相机
      this.$emit('currentCodeChange', code)
    },
    /**
     * 编辑弹框内部的方法
     */
    openRenameInput(row) {
      if (row.isMain === 1) {
        if (this.renameTagAStatus) {
          this.renameTagAStatus = false
        } else {
          this.renameTagAStatus = true
        }
      } else if (row.isMain === 0) {
        if (this.renameTagBStatus) {
          this.renameTagBStatus = false
        } else {
          this.renameTagBStatus = true
        }
      }
    },
    // 获取专业
    async getmajorList() {
      const res = await this.apiDictionary({
        method: 'query',
        params: {
          where: {
            typeName: '专业',
          },
          dataPage: {
            pageSize: 100,
            pageNo: 1,
          },
        },
      })
      if (res && res.success && res.dataList) {
        this.majorList = res.dataList
        console.log(this.majorList)
      }
    },
    // 获取碰撞报告详情
    async getClashDetail(row) {
      const res = await this.ApiClashList({
        method: 'detail',
        params: {
          id: row.id,
        },
      })
      if (res && res.code === 0) {
        this.clashDetail = _.assign(this.clashDetail, res.data)
        this.clashDetail.constructionStatus = this.clashDetail.constructionStatus === 1
        // 查看详情数据
        const [subject] = _.filter(res.data.clashObj, { isMain: 1 })
        const [object] = _.filter(res.data.clashObj, { isMain: 0 })
        this.checkDetailData = [
          {
            attr: '对象编码',
            subject: {
              code: subject.tagCode,
            },
            object: {
              code: object.tagCode,
            },
          },
          {
            attr: '对象名称',
            subject: {
              name: subject.tagName,
            },
            object: {
              name: object.tagName,
            },
          },
          {
            attr: '关联图纸',
            subject: {
              relatedDrawing: subject.relatedDrawing,
            },
            object: {
              relatedDrawing: object.relatedDrawing,
            },
          },
        ]
        console.log('拼接详情数据', this.checkDetailData)
      }
    },
    // 查看位号
    checkTag(row) {
      console.log(row)
      const currentDomain = _.split(window.location.href, '#')[0]
      console.log('当前url域名', currentDomain)
      window.open(`${currentDomain}#/assetsBrowse/newObjectBrowse/${row.tagId}`)
    },
    // 审批附件上传
    uploadApproveFile(data) {
      this.approveAttchment.push(data[0])
    },
    // 审批附件移除
    removeApproveFile(data) {
      this.approveAttchment = _.filter(this.approveAttchment, (i) => {
        return i.id !== data.id
      })
    },
    // 流程发送类型事件监听
    flowSendTypeChange(data) {
      console.log('流程发送类型单选框组', data)
      const type = _.filter(this.flowSendType, { label: data })[0]
      this.currentSendType = type.type
      console.log('当前流程发送类型', this.currentSendType)
    },
    // 修改碰撞报告并发起
    async editAndSendFlow() {
      console.log('当前流程选择类型', this.currentSendType)
      this.editAndSendLoading = true
      this.clashDetail.constructionStatus = this.clashDetail.constructionStatus ? 1 : 0
      const res = await this.ApiClashList({
        method: 'update',
        params: this.clashDetail,
      })
      console.log('修改碰撞报告', res)
      if (res && res.code === 0) {
        this.editAndSendLoading = false
        // 流程流转
        if (this.clashDetail.discipline && this.approveAdvice) {
          this.sendFlow(
            res.data.id,
            this.approveAdvice,
            this.clashDetail.clashReportNumber,
            this.currentSendType
          )
        } else if (!this.clashDetail.discipline) {
          return this.$message.warning('请选择专业再发起流程')
        } else if (!this.approveAdvice) {
          return this.$message.warning('请填写意见再发起流程')
        }
        this.editDialog = false
        // 流程异步发送请求，延迟刷新列表
        setTimeout(() => {
          this.initData()
        }, 1000)
        this.clearForm()
      } else {
        this.editAndSendLoading = false
        this.$message.error(res.msg)
      }
      return ''
    },
    // 发送流程
    async sendFlow(id, comment, title, type) {
      console.log('获取当前待办流程3', this.toDoFlowCurrent)
      if (type === 'back') {
        await this.getBackStep()
      } else {
        await this.getSendStep()
      }
      const res = await this.$store.dispatch({
        type: 'WorkFlow/excuteFlow',
        payload: {
          systemcode: this.flowSystemCode,
          flowid: this.clashFlowId,
          senderid: this.userInfo.userId,
          taskid: _.isNull(this.toDoFlowCurrent) ? null : this.toDoFlowCurrent.id,
          instanceid: id,
          comment,
          tasktitle: title,
          type,
          steps: this.nextStep,
        },
      })
      console.log('发送流程返回结果', res)
      if (res && res.errcode === 0) {
        this.$message.success(res.errmsg)
      } else {
        this.$message.error(res.errmsg)
      }
    },
    // 清除表单
    clearForm() {
      this.clashDetail = _.assign(
        {},
        {
          clashReportNumber: '',
          submitDate: '',
          constructionStatus: 0,
          area: '',
          discipline: '',
          content: '',
          clashTags: [],
        }
      )
      this.checkDetailData = [
        {
          attr: '对象编码',
          subject: {
            code: '',
          },
          object: {
            code: '',
          },
        },
        {
          attr: '对象名称',
          subject: {
            name: '',
          },
          object: {
            name: '',
          },
        },
        {
          attr: '关联图纸',
          subject: {
            relatedDrawing: [],
          },
          object: {
            relatedDrawing: [],
          },
        },
      ]
      this.currentSendLabel = '下一步'
      this.currentSendType = 'submit'
      this.approveAdvice = ''
      this.approveAttchment = []
      this.flowCommentAndAttach = []
      this.flowEndStatus = false
      this.isLastFlowNode = false
      this.renameTagAStatus = false
      this.renameTagBStatus = false
      this.isCurrentApprover = true
      // 保存状态重置
      this.editAndSendLoading = false
    },
    // 附件下载方法
    async fileDownload(data) {
      console.log(data)
      const config = { responseType: 'arraybuffer' }
      const instance = axios.create(config)
      const res = await instance.post(
        `${currentEnv.VUE_APP_PLANT_SERVER}/file/download_attachment`,
        {
          md5List: [data.md5],
          downloadType: 1,
        }
      )
      if (res && res.data) {
        this.downLoadBlob({
          name: data.name || data.fileName,
          type: res.headers['content-type'],
          data: res.data,
        })
      }
    },
    handledChecked(data) {
      console.log(data)
      this.isHandledStatus = data
    },
    /**
     * 流程相关
     */
    // 获取碰撞管理流程id
    async getClashFlowId() {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/getFlows',
        payload: {
          systemcode: this.flowSystemCode,
        },
      })
      console.log('所有流程', res)
      if (res && res.errcode === 0 && res.data) {
        this.allFlows = res.data
        console.log('碰撞管理流程名称', this.flowName)
        const flow = _.filter(this.allFlows, { Name: this.flowName })[0]
        this.clashFlowId = flow.Id
        console.log('碰撞管理流程id', this.clashFlowId)
      } else {
        this.allFlows = this.$options.data().allFlows
        this.clashFlowId = this.$options.data().clashFlowId
      }
    },
    // 下一步发送步骤，获取下一步审批人
    async getSendStep() {
      let params = null
      const currentDiscipline = _.find(this.majorList, { id: this.clashDetail.discipline })
      console.log('当前选择专业信息', currentDiscipline)
      if (this.clashDetail.flowStatus === 0) {
        params = {
          systemcode: this.flowSystemCode,
          flowid: this.clashFlowId,
          stepid: _.toLower(this.clashFlow.steps[0].id),
          taskid: null,
          userid: this.userInfo.userId,
          freesend: false,
          bsndata: {
            discipline: currentDiscipline.name,
          },
        }
      } else {
        params = {
          systemcode: this.flowSystemCode,
          flowid: this.clashFlowId,
          stepid: this.toDoFlowCurrent.stepid,
          taskid: this.toDoFlowCurrent.id,
          userid: this.userInfo.userId,
          freesend: false,
          bsndata: this.isHandledStatus ? { formstatus: 2 } : { formstatus: 1 },
        }
      }
      const res = await this.$store.dispatch({
        type: 'WorkFlow/getFlowSend',
        payload: params,
      })
      if (res && res.errcode === 0) {
        this.nextStep = res.data
        this.flowApprovers = this.nextStep.users
        console.log('下一步审批人', this.nextStep.users, this.flowApprovers)
      }
    },
    // 获取流程详细信息
    async getFlowDetail() {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/getFlow',
        payload: {
          systemcode: this.flowSystemCode,
          flowid: this.clashFlowId,
        },
      })
      if (res && res.errcode === 0) {
        this.clashFlow = JSON.parse(res.data)
        console.log('当前流程信息', this.clashFlow)
      }
    },
    // 获取实例
    async getGroupTask(groupId) {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/queryFlowLog',
        payload: {
          systemcode: this.flowSystemCode,
          groupid: groupId,
        },
      })
      console.log('当前实例组列表', res)
      if (res && res.errcode === 0) {
        return res.data
      }
      return []
    },
    // 获取当前流程待办
    async getBackLog() {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/queryBacklog',
        payload: {
          systemcode: this.flowSystemCode,
          userid: this.userInfo.userId,
          pagesize: 100,
          pagenumber: 1,
          flowid: this.clashFlowId,
          title: this.clashDetail.clashReportNumber,
          startdate: '',
          enddate: '',
          order: 'ReceiveTime DESC',
        },
      })
      if (res && res.errcode === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 获取已办
    /**
     * 已办executeType返回流程状态,看了下数据发现这个类型并不表示流程状态，而是当前步骤执行结果
     * -1：等待中  0：未处理  1：处理中  2：已完成  3：已退回  4：他人已处理  5：他人已退回  6：已转交  7：已委托  8：已阅知  9：已指派  10：已跳转  11：已终止  12：他人已终止  13：已加签
     */
    async getDoneLog() {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/queryDonelog',
        payload: {
          systemcode: this.flowSystemCode,
          userid: this.userInfo.userId,
          pagesize: 100,
          pagenumber: 1,
          flowid: this.clashFlowId,
          title: this.clashDetail.clashReportNumber,
          startdate: '',
          enddate: '',
          order: 'ReceiveTime DESC',
        },
      })
      if (res && res.errcode === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 获取所有已办列表
    async getAllDoneLog() {
      const res = await this.$store.dispatch({
        type: 'WorkFlow/queryDonelog',
        payload: {
          systemcode: this.flowSystemCode,
          userid: null,
          pagesize: 100,
          pagenumber: 1,
          flowid: this.clashFlowId,
          title: this.clashDetail.clashReportNumber,
          startdate: '',
          enddate: '',
          order: 'ReceiveTime DESC',
        },
      })
      if (res && res.errcode === 0 && res.data) {
        return res.data
      }
      return []
    },
  },
  async created() {
    // 获取页码
    this.page.pageNo = this.$route.query.pageNo ? Number(this.$route.query.pageNo) : 1
    this.page.pageSize = this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10
    await this.getClashPosition() // 从碰撞模块进入
    this.loading = true
    this.moduleAuth = await ConfirmAuth('三维检查')
    this.tableData = await this.initData()
    const row = _.find(this.tableData, ['id', this.$route.query.clashReportId])
    this.$refs.tableRef.setCurrentRow(row)
    this.$nextTick(() => {
      this.$refs.pagination.internalCurrentPage = this.page.pageNo
      this.setRowData(row)
    })
    this.loading = false
    this.getmajorList()
    // 定位到可视区域
    this.$nextTick(() => {
      const currentNode = document.getElementsByClassName('current-row')[0]
      if (currentNode) {
        this.$refs.tableRef.bodyWrapper.scrollTop = currentNode.offsetTop
      }
    })
    this.getWorkFlow()
  },
  async beforeDestroy() {
    // 检查是否有已知的标记
    const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
    _.forEach(markerList, (marker) => {
      if (this.gisMarkerList.includes(marker.id)) {
        this.player.Native.GisMarker.destroy(marker.id)
      }
    })
    // 清除碰撞体的颜色
    await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
.clashComp {
  background-color: rgba(46, 107, 176, 0.5) !important;
  position: absolute;
  height: 90%;
  width: 368px;
  top: 86px;
  right: 35px;
  border-radius: 4px;
  z-index: 99;
  padding: 10px;
}
.clash_list {
  height: calc(45% - 5px);
}
.clash_detail {
  height: calc(55% - 5px);
}
.deal_dialog {
  max-height: 70vh;
  overflow-y: auto;
}
.w-98 {
  width: 98%;
}
.clash_table {
  height: calc(100% - 110px);
}
.flow_dialog {
  height: 500px;
}
.h-80 {
  height: 80%;
}
.h-20 {
  height: 20%;
}
.clash_icon {
  font-size: 16px;
}
/deep/ .el-card__body {
  padding: 0 !important;
  height: 100%;
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.cable-info {
  .cable-info__list {
    margin-top: 4px;
    font-size: 14px;
    .info-left {
      font-size: 12px;
      width: 30%;
      height: 100%;
      display: inline-block;
      padding: 4px 5px;
      color: white;
    }
    span {
      cursor: pointer;
      color: #409eff;
    }
  }
  .b-none {
    border-bottom: none;
  }
}
.tableDiv {
  width: 100%;
  height: calc(100% - 62px);
  background-color: rgba(24, 41, 72, 0.5) !important;
  border: none !important;
  overflow: auto;
}
.clearfix {
  span {
    font-size: 14px;
  }
}
.button-color {
  border: none;
  color: #fff;
  background-color: #00c0ff !important;
}
.uploadDiv {
  /deep/.el-upload-dragger {
    background-color: transparent !important;
  }
  /deep/.el-upload__text {
    color: white !important;
  }
}
.inputDiv {
  /deep/ .el-textarea__inner {
    background-color: rgba(24, 41, 72, 0.5) !important;
    color: white !important;
  }
}
.dialogDiv {
  /deep/ .el-dialog__header {
    background-color: white !important;
    /deep/ .el-dialog__title {
      color: black !important;
    }
    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: black !important;
    }
  }
  /deep/ .el-dialog__body {
    background-color: white !important;
  }
}

</style>
